module.exports = __webpack_public_path__ + "static/media/logo.495d93cc.svg";